import { Form, FormResponseValue } from "@tellescope/types-models";

export const calculateFormScoring = ({
  response,
  form,
}: {
  response: Pick<{ responses: FormResponseValue[] }, "responses">;
  form: Pick<Form, "scoring">;
}) => {
  if (!form.scoring?.length) return;

  const scores: Record<string, number> = {};

  for (const scoreCondition of form.scoring) {
    const r = response.responses.find(
      (r) =>
        r.fieldId === scoreCondition.fieldId &&
        (r.answer.type !== "multiple_choice" ||
          (Array.isArray(r.answer.value) &&
            typeof scoreCondition.response === "string" &&
            r.answer.value.includes(scoreCondition.response)))
    );
    if (!r) continue;

    if (scores[scoreCondition.title] === undefined) {
      scores[scoreCondition.title] = 0;
    }

    if (r.answer.type === "multiple_choice" && typeof scoreCondition.score === "number") {
      scores[scoreCondition.title] = (scores[scoreCondition.title] ?? 0) + scoreCondition.score;
    } else if (typeof r.answer.value === "number") {
      scores[scoreCondition.title] = (scores[scoreCondition.title] ?? 0) + r.answer.value;
    }
  }
  if (!Object.values(scores).filter(Boolean).length) return;

  const scoresList: { title: string; value: number }[] = [];
  for (const title in scores) {
    scoresList.push({
      title,
      value: scores[title] ?? 0,
    });
  }

  return scoresList;
};
